import { flexCenter, flexRow } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

export const Buttons = styled.div`
  ${flexCenter};
`;

const selectStyles = css`
  background: var(--blue_20);
  border: 1px solid var(--blue_100);
  img {
    filter: none;
  }
`;

export const RotateButton = styled.div<{ isSelected: boolean }>`
  ${flexRow};
  flex: 1;
  cursor: pointer;
  justify-content: space-evenly;
  padding: 5px 0;
  height: 60px;
  font-weight: 700;
  background: #fff;
  color: var(--gray_900);
  border: 1px solid var(--gray_100_20);
  border-radius: 0px 10px 10px 0px;

  img {
    max-width: 54px;
    filter: var(--any_to_gray_400);
  }

  &:first-child {
    border-radius: 10px 0px 0px 10px;
  }

  ${({ isSelected }) => isSelected && selectStyles};
`;
